import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback, GlobalContext } from 'smart-react';
import { UserPlus } from 'lucide-react';
import { Card, CardContent } from '@/Modules/Core/Components/shadcn/card';
import { AppPageSection } from '@/Modules/Core/Components/Layout/AppPage';
/**
 * Users main screen
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Users component.
 */
const AddUser = () => {
  const { dimensions, deviceInfo } = React.useContext(GlobalContext);
  React.useEffect(() => {}, [dimensions, deviceInfo]);
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <div className="tw">
        <div className="space-y-6">
          <AppPageSection>
            <Card>
              <CardContent className="px-5 py-10 text-center">
                <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10 text-primary">
                  <UserPlus className="h-7 w-7" />
                </div>
                <h2 className="mt-5 text-[16px] font-semibold text-foreground">
                  Add user workflow is being standardized
                </h2>
                <p className="mx-auto mt-2 max-w-xl text-[13px] leading-6 text-muted-foreground">
                  This page now follows the shared admin layout and is ready for
                  the next implementation pass when user creation fields are added.
                </p>
              </CardContent>
            </Card>
          </AppPageSection>
        </div>
      </div>
    </ErrorBoundary>
  );
};
export default AddUser;
